import { z } from 'zod';
import { addressSchema, cosmosChainSlugSchema, evmChainSlugSchema, genericAddressSchema, solanaChainSlugSchema, supportedChainSlugSchema } from './common.js';
import { denomSchema } from './cosmos.js';
export const tokenIdentifierSchema = z.union([addressSchema, denomSchema]);
export const getTokenMetadataParamsSchema = z.object({
    chain: supportedChainSlugSchema,
    address: z.string().min(1),
    blockHeight: z.number().int().nonnegative().optional(),
}).strict();
export const tokenMetadataDataSchema = z.object({
    chain: z.union([evmChainSlugSchema, cosmosChainSlugSchema, solanaChainSlugSchema]),
    address: z.union([tokenIdentifierSchema, genericAddressSchema]),
    name: z.union([z.string().min(1), z.null()]).optional(),
    symbol: z.union([z.string().min(1), z.null()]).optional(),
    decimals: z.union([z.number().int().nonnegative(), z.null()]).optional(),
    totalSupply: z.union([z.string().min(1), z.null()]).optional(),
    uri: z.union([z.string().min(1), z.null()]).optional(),
    metadata: z.unknown().optional(),
}).strict();
